import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-functions-boss',
  slug: 'boss',
  title: 'Memoize an expensive function',
  type: 'boss',
  estSeconds: 900,
  contentVersion: 1,
});
